export default "__VITE_ASSET__CL8VRJ6x__"